export default import.meta.ROLLUP_FILE_URL_6kssa3xCT2YlMpIbbRNP$Q